import React from 'react'

const Loading = () => {
  return <section className="section section-center">
    <div className="loading"></div>
  </section>
}

export default Loading
